import * as React from "react";
import { useState, useEffect} from "react"
import {jfetch} from "../../utils"
import PageContainer from "../core/PageContainer";
import Card from "../core/Card";
import Breadcrumbs from "../core/Breadcrumbs";
import Button from "../core/Button";
import Modal from "../core/Modal";

interface IProps {
  userContext:any;
  organizations:any;
}

function QuizzesAdmin(props:IProps){
  return (
    <PageContainer>   
      <Breadcrumbs crumbs={[{ label: "Admin Quizzes Console" }]} />
      <div className="row">
        <div className="col-lg-2">
          <label>Start Date</label>
          <input type="text" className="form-control"/>
        </div>
        <div className="col-lg-2">
          <label>End Date</label>
          <input type="text" className="form-control"/>
        </div>
        {/* <div className="col-lg-2">
          <label>
            Search <i className="fa fa-search"/>
          </label>
          <input type="text" className="form-control"/>
        </div>         */}
      </div>
      {props.organizations.map((org) => <Org org={org} key={org.id} /> )}
    </PageContainer>
  )
}

interface OrgProps{
  org:any;
}

function Org(props:OrgProps){
  const [loading, setLoading] = useState(false)
  const [quizzes, setQuizzes] = useState([])

  function getQuizzes(){
    setLoading(true);
    jfetch.get('/quiz/list', {organization_id:props.org.id})
    .then((resp) => {
      let new_quizzes = []
      resp.quizzes.data.forEach(el => {
        new_quizzes.push(el.attributes)
      });
      setQuizzes(new_quizzes)
      setLoading(false)
    })
  }

  return (
    <>
    <div className="row">
      <div className="col-lg-6">
        <h2 style={{marginBottom:'0px'}}>{props.org.title}</h2>
      </div>
      <div className="col-lg-6 text-right">
        <div style={{marginTop:'20px'}}>
          <Button className="btn btn-primary btn-sm" loading={loading} onClick={getQuizzes}> 
            <i className="fa fa-chevron-down"/> View Quizzes
          </Button>
        </div>
      </div>
    </div>
    <div className="row">
      <div className="col-lg-12">
        <Card>
        { loading && (
          <div className="sk-chase">
            <div className="sk-chase-dot"></div>
            <div className="sk-chase-dot"></div>
            <div className="sk-chase-dot"></div>
            <div className="sk-chase-dot"></div>
            <div className="sk-chase-dot"></div>
            <div className="sk-chase-dot"></div>
          </div>
        )}
        {quizzes.map((quiz) => <Quiz quiz={quiz} key={quiz.id} />)}
        </Card>
      </div>
    </div>
    </>
  )
}

interface QuizProps{
  quiz:any;
}

function Quiz(props:QuizProps){
  return (
    <div className="row">
      <div className="col-lg-2">
        {props.quiz.name}
      </div>
      <div className="col-lg-2">
        {props.quiz.user}
      </div>
      <div className="col-lg-2">
        {`${props.quiz.grade}%`}
      </div>
      <div className="col-lg-2">
        {props.quiz.created_at}
      </div>
      <div className="col-lg-2">
        <ResultModal name={props.quiz.user} result_id={props.quiz.id} />
      </div>
    </div>
  )
}

interface RMProps{
  name:string;  
  result_id:number;
}

function ResultModal(props:RMProps){
  const [show, setShow] = useState(false)
  const [questions, setQuestions] = useState([])

  useEffect(() => {
    jfetch.get(`/library/quiz_results/${props.result_id}/info`)
    .then((resp) => {
      setQuestions(resp.answers)
    })
  }, [])

  return (
    <>
      <a 
        className="quote-blocks-popup"
        onClick={() => {
          setShow(true);
        }}
      >
        View Results
      </a>
      <Modal
        title={`Quiz Results - ${props.name}`}
        open={show}
        close={() => setShow(false)}
        submittable={false}
        isLarge={true}
        disallowClickOutside={true}
      >
        <div className="container-fluid">
          {questions.map((q) => {
            const icon = q.correct ? <i className="fa fa-check" style={{fontSize:'23px'}} /> : <i className="fa fa-times" style={{fontSize:'23px'}} />
            const color = q.correct ? '#d6f5d6': '#fddcdc'
            return (
              <div className="row" style={{paddingTop:'15px', paddingBottom:'15px', border:'1px #d8d2d2 dashed', backgroundColor:color}} key={q.id} >
                <div className="col-lg-1">
                  {icon}
                </div>
                <div className="col-lg-11">
                  {q.text}
                </div>
              </div>
            )
          })}
        </div>
      </Modal>
    </>    
  )
}

export default QuizzesAdmin


// WEBPACK FOOTER //
// ./app/javascript/components/pages/QuizzesAdmin.tsx